// Loads Meta's Facebook JS SDK once and initialises it for WhatsApp Embedded
// Signup. App id + version come from the backend (EX_COMM_WhatsAppSignupConfig);
// the app SECRET is never exposed to the browser. The promise is cached so the
// script is injected a single time regardless of how often a drawer opens.

let sdkPromise = null

export const loadFacebookSdk = ({ appId, version }) => {
    if (window.FB) {
        return Promise.resolve(window.FB)
    }
    if (sdkPromise) {
        return sdkPromise
    }

    sdkPromise = new Promise((resolve, reject) => {
        window.fbAsyncInit = () => {
            window.FB.init({ appId, cookie: true, xfbml: false, version })
            resolve(window.FB)
        }

        const existing = document.getElementById('facebook-jssdk')
        if (existing) {
            return
        }

        const script = document.createElement('script')
        script.id = 'facebook-jssdk'
        script.async = true
        script.defer = true
        script.crossOrigin = 'anonymous'
        script.src = 'https://connect.facebook.net/en_US/sdk.js'
        script.onerror = () => {
            sdkPromise = null
            reject(new Error('Failed to load the Facebook SDK'))
        }
        document.body.appendChild(script)
    })

    return sdkPromise
}

// True when a postMessage from the Embedded Signup flow comes from a Meta origin.
export const isMetaOrigin = (origin) =>
    origin === 'https://www.facebook.com' || origin === 'https://web.facebook.com'
